module.exports = __webpack_public_path__ + "img/1_de.cb71e49c.jpg";